export enum BraceType {
  FullTime = 'full time',
  NightTime = 'night time',
}
